<template>
    <section
        class="channelPage"
        :class="{
            leftPanelOpen: !isLeftPanelOpen,
            isTouchDevice: isTouchDevice,
            isFullScreenOpen: isFullScreenOpen,
        }"
        ref="channelPage"
    >
        <div class="channelPage__container">
            <div class="channelPage__wrapper">
                <div class="channelPage__player" ref="playerRef">
                    <div
                        class="channelPage__player_sckeleton"
                        v-show="getLoading"
                    ></div>
                    <NewHtlTvPlayer
                        :headLinks="headLinks"
                        :hls-source="hlsSource"
                        :currentItem="currentItem"
                        :currentProgramTime="timeDate"
                        :isLoggedIn="isLoggedIn"
                        :notAcces="
                            !getLoading &&
                            currentChannel &&
                            isLoggedInOrNotAccess
                        "
                        :epg="epg"
                        :timeDate="timeDate"
                        :forProblemsInfo="forProblemsInfo"
                        @toggleTvprogram="toggleTvprogram"
                        @closeLeftPanel="closeLeftPanel"
                        @toggleFullScreen="toggleFullScreen"
                        :isFullScreenOpen="isFullScreenOpen"
                        :isLeftPanelOpen="isLeftPanelOpen"
                        @liveIsStoped="liveIsStoped"
                        @getLive="loadLive"
                        @seekVideo="loadProgram"
                        @nextProgram="rightProgram"
                        @prevChannel="rightChannel"
                        @nextChannel="leftChannel"
                        v-show="
                            !getLoading && isLoggedIn && !isLoggedInOrNotAccess
                        "
                    />
                    <div
                        class="chanelStub"
                        v-show="
                            !getLoading &&
                            currentChannel &&
                            isLoggedInOrNotAccess
                        "
                        :style="{
                            backgroundImage: `url(${currentChannel?.icon})`,
                        }"
                    >
                        <div class="chanelStub__content">
                            <h1 class="title">
                                {{ currentChannel?.name }}
                            </h1>
                            <h2 v-if="!isLoggedIn">
                                {{
                                    $t("message.currentChannelItem.auth", {
                                        name: currentChannel?.name,
                                    })
                                }}
                            </h2>
                            <h2 v-else>
                                {{ $t("message.currentChannelItem.subscrib") }}
                            </h2>
                            <ElButton
                                v-if="!isLoggedIn"
                                size="medium"
                                type="default"
                                @click="$router.push('/login')"
                            >
                                {{ $t("message.neeToLogin") }}
                            </ElButton>
                            <ElButton
                                v-else
                                size="medium"
                                type="default"
                                @click="openPaymnetModal"
                            >
                                {{ $t("message.currentChannelItem.buy") }}
                            </ElButton>
                        </div>
                    </div>
                </div>
                <div class="channelPage__leftPanel">
                    <leftPannel
                        :isLoggedIn="isLoggedIn"
                        :headLinks="headLinks"
                        :days="days"
                        :currentDay="currentDay"
                        :activeSlideIndex="activeSlideIndex"
                        :headLinksActive="headLinksActive"
                        :epg="epg"
                        :currentItem="currentItem"
                        :timeDate="timeDate"
                        :notAcces="
                            !getLoading &&
                            currentChannel &&
                            isLoggedInOrNotAccess
                        "
                        @closeLeftPanel="closeLeftPanel"
                        @toggleTvprogram="toggleTvprogram"
                        @clickEpg="clickEpg"
                        @btnProgram="btnProgram"
                        @toggleLike="toggleLike"
                        @moreInfoItemActive="moreInfoItemActivate"
                    />
                    <MoreInfoModal
                        :active="moreInfoItemActive"
                        :data="moreInfoItem"
                        @moreInfoItemActive="moreInfoItemActivate"
                    />
                </div>
            </div>
        </div>
        <PaymentModal
            :type="getModalTypes[getIsPaymentModalActiveType]"
            v-if="isLoggedIn"
            @paymnetSuccess="paymnetSuccess"
            :needList="channerTarrifs"
        />
    </section>
</template>
<script>
import { defineAsyncComponent } from "vue";
import NewHtlTvPlayer from "../../components/TvPlayer/NewHtlTvPlayer.vue";
import { channelUrl, programUrl, getChannelDetail, getRpg } from "../../Api";
import STATS_VIDEO_API from "../../Api/VideoStats.js";
import { converter } from "../../converter.js";
const PaymentModal = defineAsyncComponent(() =>
    import("../../components/paymentModal/index.vue")
);
const ElButton = defineAsyncComponent(() =>
    import("../../components/ElButton/index.vue")
);
const MoreInfoModal = defineAsyncComponent(() =>
    import("../../components/Tv/MoreInfoModal.vue")
);
const leftPannel = defineAsyncComponent(() =>
    import("../../components/Tv/LeftPannel.vue")
);

import { mapGetters } from "vuex";
export default {
    name: "NewChannelPage",
    components: {
        leftPannel,
        ElButton,
        NewHtlTvPlayer,
        MoreInfoModal,
        PaymentModal,
    },
    props: ["id", "name"],
    data() {
        return {
            isLeftPanelOpen: true,
            isLoggedIn: false,
            headLinksActive: 1,
            activeSlideIndex: null,
            NowactiveSlideIndex: null,
            days: [],
            currentDay: "",
            forProblemsInfo: {
                problem_id: null,
                channel_id: null,
                channel_title: null,
                program_id: null,
                program_title: null,
            },
            epg: "",
            width: "0%",
            timer: 0,
            timeDate: {
                beginTime: 0,
                endTime: 0,
                id: 0,
            },
            interval: null,
            timeInterval: {
                beginTime: 0,
                endTime: 0,
            },
            currentItem: null,
            hlsSource: null,
            isLoggedInOrNotAccess: false,
            tvStatsIntervalId: 0,
            channelSession: 0,
            channerTarrifs: [],
            channelUrlIsLoading: false,
            moreInfoItem: {},
            moreInfoItemActive: false,
            isFullScreenOpen: false,
        };
    },
    created() {
        this.verifyAccess();
        this.gitInfoFromChannel(this.getChanelsListFull);
        // this.loadEpg(this.cid);
        this.loadTv();
        this.loadChannel(this.cid);
        this.loadChannelDetail(this.cid);
    },
    mounted() {
        this.statsTvPush();
        if (this.$route.params.lang == "uz") {
            localStorage.setItem("lang", "uz");
            this.$i18n.locale = "uz";
        } else {
            localStorage.setItem("lang", "ru");
            this.$i18n.locale = "ru";
        }
    },
    beforeUnmount() {
        clearInterval(this.tvStatsIntervalId);
        this.activeSlideIndex = null;
        this.$store.commit("setIsPaymentModalActiveType", "");
        this.$store.commit("setIsPaymentModalActive", false);
        this.$store.commit("CLEAR_CHANELSLIST");
    },

    computed: {
        ...mapGetters([
            "getWorld",
            "checkAccess",
            "getChanelsListFull",
            "getChanelsList",
            "getLoading",
            "getSelectedCategory",
            "getStaticFavs",
            "getIsPaymentModalActiveType",
            "getModalTypes",
            "getIsTelegram",
        ]),
        cid() {
            return this.$router.currentRoute.value.params.id;
        },
        currentChannel() {
            const current = this.$store.getters.getCurrentChanel(this.cid);
            if (!this.isLoggedIn) {
                this.isLoggedInOrNotAccess = true;
            }
            return current;
        },
        headLinks() {
            return [
                {
                    id: 1,
                    title: this.$t("message.tvChannel.channels"),
                },
                {
                    id: 2,
                    title: this.$t("message.tvChannel.programm"),
                },
            ];
        },
        isTouchDevice() {
            return window.matchMedia("(pointer: coarse)").matches;
        },
    },
    watch: {
        getChanelsListFull: {
            handler(newValue, oldValue) {
                if (newValue) {
                    this.gitInfoFromChannel(newValue);
                }
            },
        },
        cid() {
            clearInterval(this.tvStatsIntervalId);
            this.channelSession = Date.now();
            this.statsTvPush();
        },
        $route(to, from) {
            if (to) {
                if (to.name === "channel") {
                    this.epg = [];
                    this.days = [];
                    this.goToChanel(to.params.id);
                    this.loadChannelDetail();
                    if (this.currentChannel) {
                        document.title = this.appendChannelTitle(
                            this.currentChannel.name,
                            this.$i18n.locale
                        );
                    }
                }
            }
        },
        currentItem(to) {
            if (to) {
                this.timeInterval = {
                    beginTime: this.fullTime(Number(to.program_begin_time)),
                    endTime: this.fullTime(Number(to.program_end_time)),
                };
                document.title = this.appendChannelTitle(
                    to.name,
                    this.$i18n.locale
                );
            }
        },
    },
    methods: {
        async verifyAccess() {
            let token = localStorage.getItem("token");
            if (token) {
                this.isLoggedIn = true;
            } else {
                this.isLoggedIn = false;
            }
        },
        setPlayerHeight() {
            const ref = this.$refs.playerRef;
            const height = ref.clientHeight + 5;
            document.body.style = "--playerHeight:" + height + "px";
        },
        moreInfoItemActivate(item) {
            if (item === null) {
                this.moreInfoItemActive = false;
                return;
            }
            this.moreInfoItem = item;
            this.moreInfoItemActive = true;
        },
        async fullscreenChangeEventHandler() {
            await this.$refs.channelPage.requestFullscreen();
        },

        openPaymnetModal() {
            this.$store.commit("setIsPaymentModalActiveType", "tv");
            this.$store.commit("setIsPaymentModalActive", true);
        },
        goToChanel(s) {
            this.timeDate.beginTime = 0;
            this.timeDate.endTime = 0;
            this.timer = 0;
            this.currentItem = this.getChanelsListFull.filter(
                (item) => item.id == this.cid
            )[0];

            this.loadChannel(s);
            this.loadEpg(s);
        },
        fullTime(s) {
            return converter(s)[0];
        },
        paymnetSuccess() {
            this.$store.commit("CLEAR_CHANELS");
            this.gitInfoFromChannel(this.getChanelsListFull);
            // this.loadEpg(this.cid);
            this.loadTv();
            this.loadChannel(this.cid);
            this.loadChannelDetail(this.cid);
            this.$store.commit("SET_ACTIVE_CATEGORY", "all");
        },
        // leftPanel
        toggleLeftPanel() {
            this.isLeftPanelOpen = !this.isLeftPanelOpen;
        },
        closeLeftPanel() {
            this.isLeftPanelOpen = false;
            const that = this;
            setTimeout(() => {
                that.setPlayerHeight();
            }, 100);
        },
        openLeftPanel() {
            this.isLeftPanelOpen = true;
            const that = this;
            setTimeout(() => {
                that.setPlayerHeight();
            }, 100);
        },
        toggleTvprogram(id) {
            const that = this;
            setTimeout(() => {
                that.setPlayerHeight();
            }, 100);
            if (this.headLinksActive === id) {
                this.toggleLeftPanel();
                this.headLinksActive = id;
                return;
            }
            if (!this.isLeftPanelOpen) this.isLeftPanelOpen = true;
            this.headLinksActive = id;
        },
        toggleFullScreen() {
            if (document.fullscreenElement) {
                document.exitFullscreen();
                this.openLeftPanel();
                this.isFullScreenOpen = false;
            } else {
                const el = this.$refs.channelPage;
                if (this.userAgent !== "iPhone") {
                    if (this.getIsTelegram) {
                        if (tg.platform !== "web") {
                            if (tg.fullscreen) {
                                tg.fullscreen = false;
                                this.isFullScreenOpen = false;
                                tg.exitFullscreen();
                                this.openLeftPanel();
                            } else {
                                this.isFullScreenOpen = true;
                                tg.requestFullscreen();
                                tg.fullscreen = true;
                                this.closeLeftPanel();
                            }
                            this.$store.commit(
                                "SET_IS_FULL_SCREEN_OPEN",
                                this.isFullScreenOpen
                            );
                            setTimeout(() => {
                                this.setPlayerHeight();
                            }, 100);
                            return;
                        }
                    }
                }
                if (document.fullscreenElement) {
                    this.isFullScreenOpen = true;
                    document.exitFullscreen();
                    this.closeLeftPanel();
                } else if (el.requestFullscreen) {
                    this.isFullScreenOpen = true;
                    this.closeLeftPanel();

                    el.requestFullscreen();
                } else if (el.webkitRequestFullscreen) {
                    this.isFullScreenOpen = true;
                    this.closeLeftPanel();

                    el.webkitRequestFullscreen(); // Safari
                } else if (el.msRequestFullscreen) {
                    this.isFullScreenOpen = true;
                    this.closeLeftPanel();

                    el.msRequestFullscreen(); // IE11
                } else {
                    const video = document.querySelector(
                        ".tvPlayer__video_item"
                    );
                    if (video && video.webkitEnterFullScreen) {
                        video.webkitEnterFullScreen(); // iPhone only
                    }
                }
            }

            setTimeout(() => {
                this.setPlayerHeight();
            }, 100);
        },
        appendChannelTitle(title, lang) {
            if (!title) {
                return "Смотреть телеканал онлайн прямой эфир в хорошем качестве";
            }
            return lang === "ru"
                ? `Смотреть телеканал ${title} онлайн прямой эфир в хорошем качестве`
                : `${title} telekanalni jonli efirda, yuqori sifatda onlayn korish, tamosha qilish`;
        },
        // cnannel
        async loadLive() {
            await this.loadChannel(this.cid);
            this.activeSlideIndex = this.NowactiveSlideIndex;
            this.gitInfoFromChannel(this.getChanelsListFull);
        },
        async loadChannel(cid) {
            if (!this.isLoggedIn) return;

            if (this.channelUrlIsLoading) return;
            this.channelUrlIsLoading = true;
            if (this.currentItem) {
                if (this.currentItem.has_subscription === 0) {
                    this.isLoggedInOrNotAccess = true;
                } else {
                    this.isLoggedInOrNotAccess = false;
                }
            }
            try {
                const response = await channelUrl(cid);
                let uri = response?.uri;
                uri = uri?.replace("http:", "https:").replace(":80", "");
                this.hlsSource = uri;
                this.isLoggedInOrNotAccess = false;
                this.channelUrlIsLoading = false;
            } catch (error) {
                this.hlsSource = null;
                this.channelUrlIsLoading = false;
                if (error?.response?.data?.error == 403) {
                    this.isLoggedInOrNotAccess = true;
                }
                return;
            } finally {
                this.channelUrlIsLoading = false;
                this.setPlayerHeight();
            }

            if (this.epg) {
                let time = Number((new Date().getTime() / 1000).toFixed(0));
                for (let index = 0; index < this.epg?.length; index++) {
                    if (
                        this.epg[index].begin_time < time &&
                        this.epg[index].end_time > time
                    ) {
                        this.timeDate = {
                            beginTime: this.epg[index].begin_time,
                            endTime: this.epg[index].end_time,
                            id: this.epg[index].id,
                        };
                        let min = Number(this.timeDate.beginTime);
                        let max = Number(this.timeDate.endTime);
                        let sum = max - min;
                        this.width = `${((time - min) * 100) / sum}%`;
                        this.timer = time;
                    }
                }
            }
        },
        async loadTv() {
            if (this.getChanelsListFull.length) return;
            if (!this.getLoading) return;
            this.$store.dispatch("fetchChanels", {
                loggined: this.isLoggedIn,
                isWorld: false,
            });
        },
        gitInfoFromChannel(value) {
            if (!value) return;
            this.currentItem = value.filter((item) => item.id == this.cid)[0];
            this.forProblemsInfo.channel_id = this.currentItem?.id;
            this.forProblemsInfo.channel_title = this.currentItem?.name;
            this.forProblemsInfo.program_id = this.currentItem?.program_id;
            this.forProblemsInfo.program_title = this.currentItem?.program_name;
            this.loadEpg(this.cid);
        },
        async loadEpg(cid) {
            if (!this.isLoggedIn) return;
            this.isLoadingEpg = true;

            const currentItem =
                Math.min(this.currentItem?.max_archive_duration, 7) || 7;
            try {
                this.$store.commit("SET_LOADING_EPG", true);
                const response = await getRpg(cid, currentItem, 13);
                if (!response?.programs) {
                    this.days = [];
                    this.daydata = {};
                    this.epg = "";
                    this.activeSlideIndex = 1;
                    this.NowactiveSlideIndex = 1;

                    this.isLoadingEpg = false;
                    return;
                }
                let allData = response.programs.item
                    ? response.programs.item
                    : response.programs;
                let dates = [];
                let currentDate = "";
                if (allData.length < 2) {
                    allData = [];
                }
                allData.forEach((element, index) => {
                    allData[index].preview = allData[index].preview
                        .replaceAll("http:", "https:")
                        .replaceAll(":8180", "");
                    let D = new Date(Number(element.begin_time) * 1000);
                    let month =
                        D.getMonth() + 1 > 9
                            ? D.getMonth() + 1
                            : "0" + (D.getMonth() + 1);
                    let day = D.getDate() > 9 ? D.getDate() : "0" + D.getDate();
                    let dateItem = month + "." + day;
                    if (currentDate !== dateItem) {
                        currentDate = dateItem;
                        dates.push(currentDate);
                    }
                });
                let result = {};
                dates.forEach((element, index) => {
                    result[element] = allData.filter((program) => {
                        let D = new Date(Number(program.begin_time) * 1000);
                        let month =
                            D.getMonth() + 1 > 9
                                ? D.getMonth() + 1
                                : "0" + (D.getMonth() + 1);
                        let day =
                            D.getDate() > 9 ? D.getDate() : "0" + D.getDate();
                        let dateItem = month + "." + day;
                        return dateItem === element;
                    });
                });

                this.days = Object.keys(result);
                this.days.forEach((item, index) => {
                    if (
                        this.convertToWeekDays(item) == "Сегодня" ||
                        this.convertToWeekDays(item) == "Bugun"
                    ) {
                        this.currentDay = item;
                    }
                });
                const today = new Date();
                const formattedToday =
                    (today.getMonth() + 1).toString().padStart(2, "0") +
                    "." +
                    today.getDate().toString().padStart(2, "0");
                const current = this.days.findIndex(
                    (day) => day == formattedToday
                );
                if (this.activeSlideIndex === current) {
                    this.activeSlideIndex -= 1;
                    this.NowactiveSlideIndex -= 1;
                } else {
                    this.activeSlideIndex = current;
                    this.NowactiveSlideIndex = current;
                }

                this.daydata = result;
                this.epg = this.daydata[this.currentDay];

                let time = Number((new Date().getTime() / 1000).toFixed(0));
                for (let index = 0; index < this.epg?.length; index++) {
                    if (
                        this.epg[index].begin_time < time &&
                        this.epg[index].end_time > time
                    ) {
                        this.timeDate = {
                            beginTime: this.epg[index].begin_time,
                            endTime: this.epg[index].end_time,
                            id: this.epg[index].id,
                        };
                        let min = Number(this.timeDate.beginTime);
                        let max = Number(this.timeDate.endTime);
                        let sum = max - min;
                        this.width = `${((time - min) * 100) / sum}%`;
                        this.timer = time;
                    }
                }
                this.moreInfoItem = this.epg[0];
                this.isLoadingEpg = false;
                this.$store.commit("SET_LOADING_EPG", false);
            } catch (error) {
                this.isLoadingEpg = false;
                this.$store.commit("SET_LOADING_EPG", false);
                return;
            }
        },
        async loadProgram(pid, time) {
            const response = await programUrl(pid, time, this.cid);
            this.live = false;
            this.isPlaying = true;
            this.pid = pid;
            let uri = response?.uri;
            uri = uri?.replace("http:", "https:").replace(":80", "");
            const programTitle = this.epg?.find((program) => program.id == pid);
            this.forProblemsInfo.program_id = pid;
            this.forProblemsInfo.program_title = programTitle.name;
            this.hlsSource = uri;
        },
        async liveIsStoped(time) {
            const newtime = Math.floor(time / 1000);
            const pid = this.pid ? this.pid : this.timeDate.id;
            const response = await programUrl(pid, newtime, this.cid);
            this.live = false;
            let uri = response?.uri;
            uri = uri?.replace("http:", "https:").replace(":80", "");
            const programTitle = this.epg?.find((program) => program.id == pid);
            this.forProblemsInfo.program_id = pid;
            this.forProblemsInfo.program_title = programTitle?.name;
            this.hlsSource = uri;
            this.isPlaying = false;
        },
        async loadChannelDetail() {
            if (!this.isLoggedIn) {
                return;
            }
            const response = await getChannelDetail(
                this.$router.currentRoute.value.params.id
            );

            this.channerTarrifs = response?.actions;
            this.$store.commit(
                "setAvailableSubscriptions",
                this.channerTarrifs
            );
        },
        clickEpg(s, index) {
            this.currentDay = s;
            this.epg = this.daydata[s].map((i) => {
                i.preview = i.preview
                    .replaceAll("http:", "https:")
                    .replaceAll(":8180", "");
                return i;
            });

            this.isPlaying = true;
        },
        convertToWeekDays(string) {
            const daysRu = [
                "Воскресенье",
                "Понедельник",
                "Вторник",
                "Среда",
                "Четверг",
                "Пятница",
                "Суббота",
            ];
            const daysUz = [
                "Yakshanba",
                "Dushanba",
                "Seshanba",
                "Chorshanba",
                "Payshanba",
                "Juma",
                "Shanba",
            ];
            const locale = this.$i18n?.locale === "ru" ? "ru" : "uz";
            const days = locale === "ru" ? daysRu : daysUz;

            let newString = string.replaceAll(".", "-");
            let date = new Date();
            const year = date.getFullYear();
            let currentDate = new Date(`${year}-${newString}`);
            let lastDay = new Date(date);
            let nextDay = new Date(date);
            lastDay.setDate(date.getDate() - 1);
            nextDay.setDate(date.getDate() + 1);

            if (date.toDateString() === currentDate.toDateString()) {
                return locale === "ru" ? "Сегодня" : "Bugun";
            }
            if (currentDate.toDateString() === lastDay.toDateString()) {
                return locale === "ru" ? "Вчера" : "Kecha";
            }
            if (currentDate.toDateString() === nextDay.toDateString()) {
                return locale === "ru" ? "Завтра" : "Ertaga";
            }

            return days[currentDate.getDay()] || string;
        },
        convertToMonth(number) {
            const monthsRu = [
                "январь",
                "февраль",
                "март",
                "апрель",
                "май",
                "июнь",
                "июль",
                "август",
                "сентябрь",
                "октябрь",
                "ноябрь",
                "декабрь",
            ];
            const monthsUz = [
                "yanvar",
                "fevral",
                "mart",
                "aprel",
                "may",
                "iyun",
                "iyul",
                "avgust",
                "sentabr",
                "oktabr",
                "noyabr",
                "dekabr",
            ];
            const locale = this.$i18n?.locale === "ru" ? "ru" : "uz";
            const months = locale === "ru" ? monthsRu : monthsUz;

            return months[number - 1] || "";
        },
        rightProgram() {
            if (this.timeDate.id == 0) {
            } else {
                for (let i = 0; i < this.days.length; i++) {
                    for (
                        let j = 0;
                        j < this.daydata[this.days[i]].length;
                        j++
                    ) {
                        let item = this.daydata[this.days[i]][j];
                        if (item.id == this.timeDate.id) {
                            if (this.daydata[this.days[i]][j + 1]) {
                                let beginTime =
                                    this.daydata[this.days[i]][j + 1]
                                        .begin_time;
                                let endTime =
                                    this.daydata[this.days[i]][j + 1].end_time;
                                let time = new Date().getTime() / 1000;
                                if (beginTime > time) {
                                    this.loadChannel();
                                } else {
                                    this.timeDate = {
                                        beginTime,
                                        endTime,
                                        id: this.daydata[this.days[i]][j + 1]
                                            .id,
                                        cid: this.cid,
                                    };
                                    this.timer = parseInt(beginTime);
                                    this.loadProgram(
                                        this.daydata[this.days[i]][j + 1].id,
                                        null
                                    );
                                }

                                break;
                            }
                        }
                    }
                }
            }
        },
        rightChannel() {
            let index = 0;
            const filtered = this.getChanelsListFull.filter(
                (item) => item.has_subscription === 1
            );
            for (let i = 0; i < filtered.length; i++) {
                if (filtered[i].id == this.cid) {
                    if (i + 1 < filtered.length) {
                        index = i + 1;
                    } else {
                        index = 0;
                    }
                }
            }
            this.$router.push({
                name: "channel",
                params: {
                    id: filtered[index].id,
                    lang: this.$i18n.locale === "ru" ? "" : "uz",
                },
            });
        },

        leftChannel() {
            let index = 0;
            const filtered = this.getChanelsListFull.filter(
                (item) => item.has_subscription === 1
            );
            for (let i = 0; i < filtered.length; i++) {
                if (filtered[i].id == this.cid) {
                    if (i - 1 > 0) {
                        index = i - 1;
                    } else {
                        index = 0;
                    }
                    break;
                }
            }
            this.$router.push({
                name: "channel",
                params: {
                    id: filtered[index].id,
                    lang: this.$i18n.locale === "ru" ? "" : "uz",
                },
            });
        },
        // channel
        // stats
        statsTvPush() {
            if (this.isLoggedIn) {
                const interval = 60_000 * 1;

                const params = {
                    channel_id: this.cid,
                    channel_session: this.channelSession,
                };

                this.tvStatsIntervalId = setInterval(async () => {
                    await STATS_VIDEO_API.statsTvPush(params);
                }, interval);
            }
        },
        // stats
        // control
        btnProgram(pid, time, endTime) {
            this.timeInterval = {
                beginTime: this.fullTime(Number(time)),
                endTime: this.fullTime(Number(endTime)),
            };
            if (new Date().getTime() / 1000 < Number(time)) {
                return;
            }
            this.timer = parseInt(time);
            this.timeDate = {
                beginTime: time,
                endTime,
                id: pid,
                cid: this.cid,
            };
            this.isPlaying = true;
            this.loadProgram(pid, time);
            this.inter();
        },
        inter() {
            clearInterval(this.interval);
            this.interval = setInterval(() => {
                if (this.isPlaying) {
                    this.timer = this.timer + 1;
                }
            }, 1000);
        },
        // control
        toggleLike(chanel) {
            if (chanel.id !== this.cid) return;
            this.currentItem = this.getChanelsListFull.find(
                (item) => item.id == chanel.id
            );
        },
    },
};
</script>
<style lang="scss">
@import "../../components/Tv//styles/channel.scss";
</style>
